import { Routes } from '@angular/router';
import { LoginComponent } from './core/components/login/login.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./cabinet/cabinet.routes').then(module => module.CABINET_ROUTES),
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
